import { Spinner } from '@heroui/spinner'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { authControllerValidateResetPassword } from '@/api/auth/auth'
import { WorkflowRoute } from '@/app/routes/_app/workflows/workflows'
import { getUserInfo } from '@/features/auth'
import { NewPasswordPage } from '@/pages/new-password'
import { FullPageWrapper } from '@/shared/ui'

const searchSchemaValidation = z.object({
  token: z.string().min(1, { message: 'Token is required' }),
})
type SearchParams = z.infer<typeof searchSchemaValidation>

export const Route = createFileRoute('/new-password')({
  component: RouteComponent,
  loader: async ({ location }) => {
    try {
      const userInfo = await getUserInfo()
      if (userInfo) return redirect({ to: WorkflowRoute.to })
    } catch {
      // 🏡 stay on the page
    }

    const { token } = location.search as SearchParams
    try {
      await authControllerValidateResetPassword({ token })
    } catch {
      throw redirect({ to: WorkflowRoute.to })
    }
  },
  validateSearch: (search) => searchSchemaValidation.parse(search),
  pendingComponent: () => (
    <FullPageWrapper>
      <div className="flex w-full flex-col items-center justify-center">
        <Spinner size="lg" />
      </div>
    </FullPageWrapper>
  ),
  onError: () => {
    throw redirect({ to: WorkflowRoute.to })
  },
})

export const NewPasswordRoute = Route

function RouteComponent() {
  return <NewPasswordPage />
}
